import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AuthService from "services/AuthService";
import { message } from "antd";
import { jwtDecode } from "jwt-decode";
import UserService from "services/UserService";
import { SELECTED_COUNTRY } from "constants/AppConstants";
import { setCurrencyCode } from "utils/cryptoUtils";
import { CURRENCY_CODE } from "configs/AppConfig";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  countryInitialData: null,
  userData: null,
  singleUser: null,
  redirect: "",
  signinTriggered: null,
  encryption: null,
  token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    const { Username, password } = data;

    try {
      const response = await AuthService.login({
        username: Username,
        password,
      });
      const token = response.data?.access_token;
      const defaultCountry = response.data?.country_data;

      if (token) {
        localStorage.setItem(AUTH_TOKEN, token);
        localStorage.setItem(
          SELECTED_COUNTRY,
          JSON.stringify({ ...defaultCountry, id: defaultCountry.country_id })
        );
        setCurrencyCode(defaultCountry?.currency_code);
        console.warn(defaultCountry, "country-eeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
        return response;
      } else {
        return rejectWithValue(response.status.message);
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Login error");
    }
  }
);

export const Encryption = createAsyncThunk(
  "auth/Encryption",
  async ({ rejectWithValue }) => {
    try {
      const response = await AuthService.Encryption();
      console.warn(response, "response enc");
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Login error");
    }
  }
);

export const signUp = createAsyncThunk(
  "auth/register",
  async (data, { rejectWithValue }) => {
    const { email, password } = data;
    try {
      const response = await AuthService.register({ email, password });
      const token = response.data.token;
      localStorage.setItem(AUTH_TOKEN, token);

      return token;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const signOut = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.logout();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const sessionSignOut = createAsyncThunk(
  "auth/sessionLogout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.logout();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth();
      const token = response.data.token;
      localStorage.setItem(AUTH_TOKEN, token);
      return token;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth();
      const token = response.data.token;
      localStorage.setItem(AUTH_TOKEN, token);
      return token;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const getUserdata = createAsyncThunk(
  "auth/getUserData",
  async (_, { rejectWithValue }) => {
    try {
      const response = localStorage.getItem(AUTH_TOKEN)
        ? jwtDecode(localStorage.getItem(AUTH_TOKEN))
        : null;
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const getSingleUser = createAsyncThunk(
  "auth/getSingleUser",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserService.getSingleUser(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
    clearUserData: (state) => {
      state.userData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.signinTriggered = "triggered";
        state.token = action.payload.data?.access_token;
        state.countryInitialData = action.payload.data?.country_data;
        state.encryption = action.payload.data?.encryption;
        state.singleUser = null;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(Encryption.pending, (state) => {
        state.loading = true;
      })
      .addCase(Encryption.fulfilled, (state, action) => {
        state.loading = false;
        console.warn(action.payload);
        state.encryption = action.payload.data?.encryption;
      })
      .addCase(Encryption.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.pending, (state) => {
        state.loading = true;
      })
      .addCase(signOut.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status.status_code) {
          message.success(action.payload.status.message);
          localStorage.removeItem(AUTH_TOKEN);
          localStorage.removeItem(SELECTED_COUNTRY);
          localStorage.removeItem(CURRENCY_CODE);
          state.token = null;
          state.redirect = "/";
          state.signinTriggered = null;
          state.singleUser = null;
        } else {
          message.success(action.payload.status.message);
        }
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
      })
      .addCase(sessionSignOut.pending, (state) => {
        state.loading = true;
      })
      .addCase(sessionSignOut.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status.status_code) {
          localStorage.removeItem(AUTH_TOKEN);
          localStorage.removeItem(SELECTED_COUNTRY);
          localStorage.removeItem(CURRENCY_CODE);
          state.token = null;
          state.redirect = "/";
          state.singleUser = null;
        } else {
          message.success(action.payload.status.message);
        }
      })
      .addCase(sessionSignOut.rejected, (state) => {
        state.loading = false;
      })
      .addCase(signUp.pending, (state) => {
        state.loading = true;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signInWithFacebook.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signInWithFacebook.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getUserdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserdata.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(getUserdata.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(getSingleUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleUser.fulfilled, (state, action) => {
        state.loading = false;
        state.singleUser = action.payload;
      })
      .addCase(getSingleUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
  clearUserData,
} = authSlice.actions;

export default authSlice.reducer;
